import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OperationLabel } from '@core/models/operation-label.model';
import { LabelColorStyles, labelColorStyles } from '@shared/utils/label-color.util';

/**
 * A label pill in the label's colour (PB-5281): load cards, the Load Details
 * drawer and the label filters. Inactive labels get a dashed border.
 */
@Component({
  selector: 'hmt-label-chip',
  templateUrl: './label-chip.component.html',
  styleUrls: ['./label-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LabelChipComponent {
  @Input() set label(label: OperationLabel) {
    this.labelValue = label;
    this.styles = labelColorStyles(label?.color);
  }
  /** chip: drawer/card size (25px); pill: dropdown option size (21px). */
  @Input() size: 'chip' | 'pill' = 'chip';
  @Input() removable = false;
  @Input() showInactive = true;
  @Output() removed = new EventEmitter<OperationLabel>();

  labelValue: OperationLabel;
  styles: LabelColorStyles = labelColorStyles(null);

  get inactive(): boolean {
    return this.showInactive && !!this.labelValue && !this.labelValue.active;
  }

  remove(event: MouseEvent) {
    event.stopPropagation();
    this.removed.emit(this.labelValue);
  }
}
